"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;

var _reactIntl = require("react-intl");

var messages = (0, _reactIntl.defineMessages)({
  errorDuringApisFetch: {
    "id": "apis.errorDuringApisFetch",
    "defaultMessage": "An error occurred while fetching the APIs."
  },
  apiIdPlaceholder: {
    "id": "apis.apiIdPlaceholder",
    "defaultMessage": "Enter an ID"
  },
  apiName: {
    "id": "apis.apiName",
    "defaultMessage": "Name"
  },
  apiNamePlaceholder: {
    "id": "apis.apiNamePlaceholder",
    "defaultMessage": "Choose a name"
  },
  apiSecret: {
    "id": "apis.apiSecret",
    "defaultMessage": "Secret"
  },
  apiSecretPlaceholder: {
    "id": "apis.apiSecretPlaceholder",
    "defaultMessage": "Create an API secret"
  },
  apiDescription: {
    "id": "apis.apiDescription",
    "defaultMessage": "Description"
  },
  apiDescriptionPlaceholder: {
    "id": "apis.apiDescriptionPlaceholder",
    "defaultMessage": "Enter a description"
  },
  permissions: {
    "id": "apis.permissions",
    "defaultMessage": "Permissions"
  },
  permissionsDescription: {
    "id": "apis.permissionsDescription",
    "defaultMessage": "Enter a permission ID"
  },
  claims: {
    "id": "apis.claims",
    "defaultMessage": "Claims"
  },
  claimsDescription: {
    "id": "apis.claimsDescription",
    "defaultMessage": "Enter a claim"
  },
  updateApi: {
    "id": "apis.updateApi",
    "defaultMessage": "Update API"
  },
  deleteApi: {
    "id": "apis.deleteApi",
    "defaultMessage": "Delete API"
  },
  deleteDesc: {
    "id": "apis.deleteDesc",
    "defaultMessage": "Are you sure you want to delete this API?"
  },
  deleteDesc2: {
    "id": "apis.deleteDesc2",
    "defaultMessage": "This action cannot be undone."
  },
  addNewApi: {
    "id": "apis.addNewApi",
    "defaultMessage": "Add new API"
  },
  selectAApiToUpdateIt: {
    "id": "apis.selectAApiToUpdateIt",
    "defaultMessage": "Select an API to see or edit its details."
  },
  apiSuccessfullyCreated: {
    "id": "apis.apiSuccessfullyCreated",
    "defaultMessage": "Api was successfully created."
  },
  errorDuringApiCreation: {
    "id": "apis.errorDuringApiCreation",
    "defaultMessage": "There was an error while creating an API."
  },
  apiSuccessfullyUpdated: {
    "id": "apis.apiSuccessfullyUpdated",
    "defaultMessage": "Api was successfully updated."
  },
  apiSuccessfullyDeleted: {
    "id": "apis.apiSuccessfullyDeleted",
    "defaultMessage": "Api was successfully deleted."
  },
  errorDuringApiUpdate: {
    "id": "apis.errorDuringApiUpdate",
    "defaultMessage": "There was an error while updating an API."
  },
  errorDuringApiDeletion: {
    "id": "apis.errorDuringApiDeletion",
    "defaultMessage": "There was an error while deleting an API."
  },
  scopes: {
    "id": "apis.scopes",
    "defaultMessage": "Scopes"
  },
  apiAlreadyExists: {
    "id": "apis.apiAlreadyExists",
    "defaultMessage": "API with this ID already exists."
  }
});
exports.messages = messages;
//# sourceMappingURL=apis-i18n.js.map